import { put, takeEvery, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import cartApi from '../../api/cart';
import checkoutAPI from '../../api/checkout';
import customerAPI from '../../api/customer';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerOrderInfosRequest({ order }) {
  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);

    let hashes = order.hash ? [order.hash] : undefined;

    if (!hashes) {
      hashes = yield call(cartApi.getOrders, siteId, order.id);
    }

    const sellers = [];

    for (const hash of hashes) {
      const data = yield call(customerAPI.orderInformations, hash, 'load', token, siteId);

      const {
        pagamentos: { formasPagamento },
      } = data;

      if (['PED', 'CPP'].includes(data.statusPedido.key)) {
        const billetPayment = formasPagamento.find((item) => item.formaPagamento === 'BA' && !item.parcelas[0].pago);
        const depositPayment = formasPagamento.find((item) => item.formaPagamento === 'DP' && !item.parcelas[0].pago);

        if (billetPayment) {
          try {
            data.billet = yield call(checkoutAPI.createBillet, siteId, hash);
          } catch (error) {
            data.paymentError = error;
          }
        }

        if (depositPayment) {
          try {
            data.depositAccounts = yield call(checkoutAPI.depositAccounts, depositPayment.empresa.id, token, siteId);
          } catch (error) {
            data.paymentError = error;
          }
        }

        for (const payment of formasPagamento) {
          if (payment.formaPagamento === 'CC' && !payment.parcelas[0].pago) {
            payment.creditCard = true;
          } else if (payment.formaPagamento === 'PX' && !payment.parcelas[0].pago) {
            try {
              const plataform = app.getIn(['plataform']);
              const size = plataform === 'mobile' ? 230 : 350;

              const queryParams = {
                idPagamento: payment.idPagamento,
                media: 'SVG',
                width: size,
                height: size,
              };

              payment.pix = yield call(checkoutAPI.pixPayment, hash, token, siteId, queryParams);
            } catch (error) {
              data.paymentError = error;
            }
          }
        }
      }

      if (['PED', 'AFT', 'CPP'].includes(data.statusPedido.key)) {
        for (const payment of formasPagamento) {
          if (payment.formaPagamento === 'BP') {
            for (const installment of payment.parcelas) {
              if (installment.idParcela && !installment.pago) {
                try {
                  installment.billet = yield call(checkoutAPI.createBillet, siteId, hash, installment.idParcela);
                } catch (error) {
                  data.paymentError = error;
                }
              }
            }
          }
        }
      }

      sellers.push(data);
    }

    yield put(Creators.customerOrderInfoSuccess(order, { loaded: true, sellers }));
  } catch (error) {
    yield put(Creators.customerOrderInfosFailed(formatError(error)));
  } finally {
    yield put(Creators.customerOrderInfosLoaded(order.id));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ORDER_INFOS_REQUEST, customerOrderInfosRequest);
}
